module.exports = __webpack_public_path__ + "img/3-en.dd36eb7b.jpg";